import { LoadingIconButton } from '@chipinside/frontend'
import { PageBuilder } from '@chipinside/pagebuilder'
import { Translate } from '@chipinside/translate'
import { SxProps, Theme } from '@mui/material/styles'
import { isEmpty } from 'lodash'

import { Drawer } from '#/components/Drawer'
import { Icon } from '#/components/Icon'
import { usePermissions } from '#/store/ducks/permissions'
import Palette from '#/styles/Palette'

export interface Value {
  url?: string
}

interface TypeTreatmentProps {
  value?: Value | null
  sx?: SxProps<Theme>
}

/**
 * Exibe um botão para visualizar detalhes do tratamento, se houver URL.
 */
export const TypeTreatment: React.FC<TypeTreatmentProps> = ({ sx, value }) => {
  const permissions = usePermissions()
  if (!value || isEmpty(value) || !value.url) return '-'

  if (!permissions?.farm?.list_health_event) {
    return <Icon size="large" name="briefcase-medical" color={Palette.red.peach[400]} />
  }

  const handleClick = () => {
    Drawer.open({
      content: <PageBuilder controller={value.url as string} />,
    })
  }

  return (
    <LoadingIconButton
      icon={<Icon size="large" name="briefcase-medical" color={Palette.red.peach[400]} />}
      title={Translate({
        messageKey: 'view_item',
        params: { item: Translate({ lower: true, messageKey: 'treatment' }) },
      })}
      onClick={handleClick}
      // @ts-ignore
      sx={sx}
    />
  )
}
